import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle, Shield, Zap, Globe, Lock } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-16 px-4 overflow-hidden bg-cream" data-id="element-209">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center" data-id="element-210">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold/30 bg-white text-ink font-medium text-xs sm:text-sm tracking-wide mb-6 shadow-sm" data-id="element-211">
          <span className="text-gold" data-id="element-212">🏷️</span> Material docente para
          Industrialización de Alimentos · Latinoamérica
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-8 text-green" data-id="element-213">
          Todo tu año de Industrialización de Alimentos{' '}
          <span className="text-terracota" data-id="element-214">
            organizado y listo para enseñar.
          </span>
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative mb-8 max-w-xl mx-auto" data-id="element-215">
          <div className="absolute inset-0 bg-gold/10 blur-[80px] rounded-full" data-id="element-216"></div>
          <img src="https://cdn.magicpatterns.com/uploads/o7KcR1mACBWS2XPuYH27c6/seguridad_e_higiene_(3).png" alt="Mega Pack Industrialización de Alimentos en el Aula" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-217" />
        </motion.div>

        <p className="text-base sm:text-lg text-slate mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-218">
          Contenidos, actividades, evaluaciones y proyectos productivos —
          estructurados en un sistema completo para el aula técnica.
        </p>

        <div className="flex flex-col gap-3 mb-8 text-left max-w-md mx-auto" data-id="element-219">
          {['Planificás el año en una tarde', 'Entrás al taller con todo preparado', 'Enseñás el proceso completo: de la materia prima al mercado', 'Evaluás sin construir nada desde cero'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-220">
              <CheckCircle size={20} className="text-terracota shrink-0 mt-0.5" data-id="element-221" />
              <span className="text-ink font-medium" data-id="element-222">{item}</span>
            </div>)}
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-223">
          <Button href="#pricing" variant="green" className="w-full sm:w-auto" data-id="element-224">
            QUIERO MI MEGA PACK AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate font-medium" data-id="element-225">
            <span className="flex items-center gap-1" data-id="element-226">
              <Lock size={14} className="text-gold" data-id="element-227" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-228">
              <Zap size={14} className="text-gold" data-id="element-229" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-230">
              <Shield size={14} className="text-gold" data-id="element-231" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-232">
              <Globe size={14} className="text-gold" data-id="element-233" /> Pagás en tu moneda local
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}